import React, { useContext } from 'react';
import RestSelect from 'components/RestInput/RestSelect';
import { Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import RestInputItem from 'components/RestInput/RestInputItem';
import ReferenceInput from 'containers/rest/ReferenceInput';
import { RestFormDateRagePicker } from 'components/RestInput/RestDateTimePicker';
import moment from 'moment';
import { RestInputContext } from 'components/RestInput/RestInputContext';

const Filter = () => {
  const { handleSubmit } = useContext(RestInputContext);
  const statuses = useSelector((state) => state.config?.data?.orderStatus);
  const orderRequirements = useSelector(
    (state) => state.config?.data?.orderRequirement,
  );
  const platform = useSelector((state) => state.config?.data?.platform);
  const orderFeatures = useSelector(
    (state) => state.config?.data?.orderFeature,
  );
  const productCatalogs = useSelector(
    (state) => state.config?.data?.productType,
  );

  return (
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <RestInputItem
          placeholder="Search by id, name,..."
          source="q"
          header="Search"
          onPressEnter={() => {
            handleSubmit();
          }}
        />
        <br />
      </Col>
      <Col xs={24} md={12}>
        <RestInputItem isReference>
          <ReferenceInput source="niche.$in" resource="niches">
            <RestSelect
              ruleType="array"
              titleProp="name"
              valueProp="id"
              selectProps={{ mode: 'multiple' }}
              source="niche.$in"
              placeholder="orders.niche"
              isAutoUpdate
              header="orders.niche"
            />
          </ReferenceInput>
        </RestInputItem>
        <br />
      </Col>
      <Col xs={24} md={12}>
        <RestSelect
          ruleType="array"
          selectProps={{ mode: 'multiple' }}
          source="status.$in"
          placeholder="orders.status"
          isAutoUpdate
          resourceData={statuses}
          header="orders.status"
        />
        <br />
      </Col>
      <Col xs={24} md={12}>
        <RestSelect
          ruleType="array"
          selectProps={{ mode: 'multiple' }}
          source="orderFeature.$containAll"
          placeholder="orders.orderFeature"
          isAutoUpdate
          resourceData={orderFeatures?.map((e) => ({
            ...e,
            text: e.text,
          }))}
          header="orders.orderFeature"
        />
        <br />
      </Col>
      <Col xs={24} md={12}>
        <RestSelect
          ruleType="array"
          selectProps={{ mode: 'multiple' }}
          source="productCatalogIds.$containAll"
          placeholder="orders.productCatalogIds"
          isAutoUpdate
          valueProp="id"
          resourceData={productCatalogs?.map((e) => ({
            ...e,
            text: e.name,
          }))}
          header="orders.productCatalogIds"
        />
        <br />
      </Col>
      <Col xs={24} md={12}>
        <RestSelect
          ruleType="array"
          selectProps={{ mode: 'multiple' }}
          source="platform.$in"
          placeholder="orders.platform"
          isAutoUpdate
          resourceData={platform}
          titleProp="name"
          valueProp="id"
          header="orders.platform"
        />
      </Col>
      <Col xs={24} md={12}>
        <RestSelect
          ruleType="array"
          selectProps={{ mode: 'multiple' }}
          source="orderRequirementId.$id"
          placeholder="orders.orderRequirementId"
          isAutoUpdate
          titleProp="name"
          valueProp="id"
          resourceData={orderRequirements}
          header="orders.orderRequirementId"
        />
      </Col>

      <Col xs={24} md={12}>
        <RestFormDateRagePicker
          source="deadline"
          placeholder="orders.deadline"
          header="orders.deadline"
          formatDefault={(value) => [moment(value.$gte), moment(value.$lte)]}
        />
      </Col>
    </Row>
  );
};

Filter.propTypes = {};

export default Filter;
